import { AppDispatch } from '@/app/store';
import { AtlasDepartmentDTO } from '@/types/atlas/AtlasDepartmentDTO';
import { AtlasRegionDTO } from '@/types/atlas/AtlasRegionDTO';
import { DepartmentButton } from '@/components/help/departments/DepartmentButton';
import { Grid } from '@mui/material';
import { NavigateFunction, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { ROUTE_HELP_REGIONS, getHelpDepartmentsRoute } from '@/app/routes';
import { getRegion, setAtlasRegion } from '@/services/helpSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import React, { FC, ReactElement } from 'react';

type Params = {
  regId: string;
};

interface OutletProps {
  regions?: AtlasRegionDTO[];
}

export const Departments: FC = (): ReactElement => {
  const { regions } = useOutletContext<OutletProps>();

  const { regId } = useParams<Params>();
  const dispatch: AppDispatch = useAppDispatch();
  const navigate: NavigateFunction = useNavigate();

  let region: AtlasRegionDTO | null = useAppSelector(getRegion);
  if (!region && regions) {
    const currentRegion: AtlasRegionDTO | undefined = regions.find((region: AtlasRegionDTO): boolean => {
      return region.id === parseInt(String(regId));
    });
    if (currentRegion) {
      region = currentRegion;
      dispatch(setAtlasRegion(currentRegion));
    } else {
      navigate(ROUTE_HELP_REGIONS, { replace: true });
    }
  }
  const handleClickDepartment = (depId: number): void => {
    if (region) {
      navigate(getHelpDepartmentsRoute(region.id, depId));
    }
  };

  return (
    <Grid container={true} direction={'row'} rowSpacing={1} columnSpacing={3}>
      {(region?.departments || []).map((department: AtlasDepartmentDTO) => (
        <Grid item={true} key={department.id} xs={12} sm={6}>
          <DepartmentButton
            region={region}
            department={department}
            onClick={(): void => handleClickDepartment(department.id)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
